import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { InfluenceAreaComponent } from './influence-area.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    InputBoxModule,
    BlockModalDragModule,
  ],
  declarations: [InfluenceAreaComponent],
  exports: [InfluenceAreaComponent],
})
export class InfluenceAreaModule {}
